import { render, staticRenderFns } from "./PhraseAdder.vue?vue&type=template&id=7b8e54c6&scoped=true"
import script from "./PhraseAdder.vue?vue&type=script&lang=js"
export * from "./PhraseAdder.vue?vue&type=script&lang=js"
import style0 from "./PhraseAdder.vue?vue&type=style&index=0&id=7b8e54c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8e54c6",
  null
  
)

export default component.exports